<template>
  <div class="four">

    <img src="../../assets/State/404.png" alt="">

    <p>
      呃，非常抱歉，数据加载失败<br/>
      您可以尝试<span @click="link">重新加载</span>
    </p>

  </div>
</template>

<script>
export default {
  name: "Four",
  data() {
    return{

    }
  },
  created() {

  },
  methods: {
    link() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="less" scoped>
.four{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.75rem;
  img{
    width: 90%;
  }
  p{
    font-size: 0.8125rem;
    text-align: center;
    color: #808080;
    span{
      color: #3B9CFD;
    }
  }
}
</style>
